import React, { Component, Fragment } from 'react';
import { Form, FormControl } from 'react-bootstrap';
import Header from '../../../global_components/Header';
import RequiredLabel from '../../../global_components/RequiredLabel';
import { getValueFromInputData } from '../../../helpers/objects';

export class Confirmation extends Component {
	constructor(props) {
		super(props);
		this.nameInput = React.createRef();
	}
	componentDidMount() {
		this.nameInput.current.focus();
	}
	render() {
		const { inputData } = this.props;
		return (
			<Fragment>
				<Header head="Confirm your appointment" subHead="So we know who's confirming, please enter your name." />
				<div className="d-flex justify-content-center">
					<Form.Group>
						<Form.Label className="label">First and Last name <RequiredLabel /></Form.Label>
						<FormControl
							size="sm"
							defaultValue={ getValueFromInputData(inputData, 'confirmation-name') }
							onChange={ (event) => { this.props.inputChange({ event }); } }
							name="confirmation-name"
							ref={ this.nameInput }
							maxLength="50"
						/>
					</Form.Group>
				</div>
			</Fragment>
		);
	}
}

export default Confirmation;
